import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import messages from './langs'

import {NaviLanguage} from '../assets/js/global'
Vue.use(VueI18n);

// 默认使用英语
const lang = window.language || 'en'; 

const list = {
  'zh': "zh_CN",
  'en': "en_US"
}


// 将语言设置保存到localStorage
localStorage.setItem('lang', list[lang]);
console.log(list[lang])

const l = localStorage.getItem('lang') || NaviLanguage();

const i18n = new VueI18n({
  locale: l === 'zh_CN' ? 'cn' : l === 'en_US' ? 'en' : undefined, // 初始未选择默认 cn 中文
  messages,
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value));// 兼容element

// 将i18n实例暴露到全局作用域，这样普通JS文件可以使用
window.$i18n = i18n;
  
// zh_CN en_US
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js